import type React from 'react';

import type { FacebookPostSheetProps } from '../../types';
import { CaptionPreview } from '../CaptionPreview';
import { CopiedPill } from '../CopiedPill';

type Props = Pick<FacebookPostSheetProps, 'caption' | 'petition' | 'copied'> & { copySuccessLabel: string };

/**
 * The `variant_1` sheet body: the copied pill when the Facebook tap copied the post, then the post
 * preview.
 */
export const FeedStep: React.FC<Props> = ({ caption, petition, copied, copySuccessLabel }) => (
	<div className="flex w-full flex-col items-center gap-4">
		{copied && <CopiedPill label={copySuccessLabel} />}
		<CaptionPreview caption={caption} petition={petition} />
	</div>
);
